type AppConfig = {
  BASE_URL: string;
  PAYPAL_ID: string;
  MIN_DATE: string;
  MAX_DATE: string;
  NODE_ENV: string;
};

const config: AppConfig = {
  BASE_URL: process.env.REACT_APP_BASE_URL || '',
  PAYPAL_ID: process.env.REACT_APP_PAYPAL_ID || '',
  MIN_DATE: process.env.REACT_APP_MIN_DATE || '',
  MAX_DATE: process.env.REACT_APP_MAX_DATE || '',
  NODE_ENV: process.env.NODE_ENV || 'development',
};

export default config;

